export default __webpack_public_path__ + "static/media/canada-flag.58da66e6.svg";